// extracted by mini-css-extract-plugin
export default {"grid":"Keypad_grid__fOho9","key":"Keypad_key__ZdlWx","fn":"Keypad_fn__A4lut","chips":"Keypad_chips__+ULtL","chip":"Keypad_chip__8fBVx"};